var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.155,
    y1: 129.455,
    x2: 213.005,
    y2: 129.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6679b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbccf8"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.08,
    cy: 129.455,
    rx: 89.925,
    ry: 88.343,
    style: {
      fill: "url(#linear-gradient)",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.724,
    y: 40.206,
    width: 97.573,
    height: 146.843,
    rx: 5.962,
    ry: 5.962,
    style: {
      fill: "#29b473"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.265,
    y: 48.928,
    width: 81.666,
    height: 124.754,
    rx: 4.841,
    ry: 4.841,
    style: {
      fill: "#e0dbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.111,184.478h0c-2.199,0-3.998-1.799-3.998-3.998h0c0-2.199,1.799-3.998,3.998-3.998h0c2.199,0,3.998,1.799,3.998,3.998h0c0,2.199-1.799,3.998-3.998,3.998Z",
    style: {
      fill: "#e0dbc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.688,
    cy: 85.926,
    rx: 4.624,
    ry: 3.959,
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.548,98.487c.011-.567-.018-1.323-.14-2.285-.32-2.525-5.482-5.735-5.482-5.735h-4.476s-5.161,3.209-5.482,5.735c-.212,1.674-.143,2.724-.072,3.242v.831c0,.178.248.323.551.323h14.551c.303,0,.551-.145.551-.323v-1.763c0-.008-.001-.016-.002-.024Z",
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.577,
    y: 109.604,
    width: 22.454,
    height: 1.613,
    rx: 0.692,
    ry: 0.692,
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.198,105.919h-8.788c-4.624,0-8.386-3.762-8.386-8.385v-11.612c0-4.624,3.762-8.386,8.386-8.386h8.788c4.624,0,8.386,3.762,8.386,8.386v11.612c0,4.624-3.762,8.385-8.386,8.385ZM103.41,78.826c-3.913,0-7.096,3.184-7.096,7.096v11.612c0,3.913,3.183,7.096,7.096,7.096h8.788c3.913,0,7.096-3.183,7.096-7.096v-11.612c0-3.913-3.183-7.096-7.096-7.096h-8.788Z",
    style: {
      fill: "#f1ba1b"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.177,79.364h-8.7c-1.025,0-1.855-.798-1.855-1.782v-8.359c0-.984.831-1.782,1.855-1.782h8.7c1.025,0,1.855-.798,1.855-1.783v-8.458c0-.984.831-1.782,1.855-1.782h8.7c1.025,0,1.855.798,1.855,1.782v8.458c0,.984.831,1.783,1.855,1.783h8.803c1.025,0,1.855.798,1.855,1.782v8.359c0,.984-.831,1.782-1.855,1.782h-8.803c-1.025,0-1.855.798-1.855,1.783v8.36c0,.984-.831,1.783-1.855,1.783h-8.7c-1.025,0-1.855-.798-1.855-1.783v-8.36c0-.984-.831-1.783-1.855-1.783Z",
    style: {
      fill: "#284049"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.378,127.66c.052-3.218-.088-7.506-.678-12.965-1.19-11.007-16.192-24.304-23.086-29.878-2.121-1.716-4.799-2.662-7.572-2.662h-13.345c-2.773,0-5.45.946-7.572,2.662-6.893,5.574-21.896,18.871-23.086,29.878-.97,8.973-.725,14.785-.407,17.876.036.345.057.691.057,1.038v4.194c0,1.009,1.2,1.834,2.666,1.834h70.366c1.466,0,2.666-.825,2.666-1.834v-10.004c0-.047-.005-.093-.01-.139Z",
    style: {
      fill: "#284049"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.37,
    cy: 55.528,
    rx: 25.252,
    ry: 23.325,
    style: {
      fill: "#284049"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUser);
export default __webpack_public_path__ + "static/media/CreateUser.f293e91d126ede282a34e4d4ef2eaca5.svg";
export { ForwardRef as ReactComponent };